import type { DetailsSidebarDisplayItem } from '../../detailssidebar/types';
import type { AssetItem, Driver } from '../redux/types';
import { getDriverNameOfDriverId } from './driverService';
import { getVehicleNameOfAssetId } from './vehicleService';

export const addDriverAndAssetInfoToDetailsSidebarDisplayItem = (
    displayItems: DetailsSidebarDisplayItem[],
    vehicles: AssetItem[],
    drivers: Driver[]
): DetailsSidebarDisplayItem[] =>
    displayItems.map(displayItem => {
        const resolvedDriverName = getDriverNameOfDriverId(displayItem.driverId, drivers);
        return {
            ...displayItem,
            vehicleName: getVehicleNameOfAssetId(displayItem.assetId, vehicles),
            driverName: resolvedDriverName ? resolvedDriverName : displayItem.driverName,
        };
    });
